import React from "react"
import { config } from "../../core/constants"

function Footer() {
  return (
    <footer className="wk-footer wk-footer-workflow" role="contentinfo">
      <div
        className="wk-footer-container wk-footer-container-workflow"
        role="navigation"
      >
        <ul className="wk-footer-navigation wk-footer-navigation-workflow">
          {/*<li className="wk-footer-item">
            <a className="wk-footer-link" href="preventDefault()">
              Disclaimer
            </a>
          </li>
          <li className="wk-footer-item">
            <a className="wk-footer-link" href="preventDefault()">
              Privacy statement
            </a>
          </li>
          <li className="wk-footer-item">
            <a className="wk-footer-link" href="preventDefault()">
              Terms & conditions
            </a>
          </li>*/}
          <li className="wk-footer-item">
            <ul className="wk-footer-item-social wk-footer-item-social-workflow">
              <li className="wk-social-item">
                {/*<a
                  className="wk-social-link wk-social-link-workflow"
                  href="preventDefault()"
                >
                  <span
                    className="wk-icon-filled-linkedin"
                    aria-hidden="true"
                  ></span>
                  <span className="wk-social-link-label">Linkedin</span>
                </a>*/}
              </li>
              <li className="wk-social-item">
                {/*<a
                  className="wk-social-link wk-social-link-workflow"
                  href="preventDefault()"
                >
                  <span
                    className="wk-icon-filled-twitter"
                    aria-hidden="true"
                  ></span>
                  <span className="wk-social-link-label">Twitter</span>
                </a>*/}
              </li>
            </ul>
          </li>
        </ul>
        <div className="wk-footer-copyright-info wk-footer-copyright-info-workflow">
          © {config.copyright} Wolters Kluwer. All rights reserved. | Powered by <strong style={{ color: "#007ac3" }}>Digital Twin</strong>
        </div>
        <ul className="wk-footer-navigation wk-footer-navigation-workflow">
          <li className="wk-footer-item">
            <ul className="wk-footer-item-social wk-footer-item-social-workflow">
              <li className="wk-social-item">
                {/*<a
                  className="wk-social-link wk-social-link-workflow"
                  href="preventDefault()"
                >
                  <span
                    className="wk-icon-filled-linkedin"
                    aria-hidden="true"
                  ></span>
                  <span className="wk-social-link-label">Linkedin</span>
                </a>*/}
              </li>
              <li className="wk-social-item">
                {/*<a
                  className="wk-social-link wk-social-link-workflow"
                  href="preventDefault()"
                >
                  <span
                    className="wk-icon-filled-twitter"
                    aria-hidden="true"
                  ></span>
                  <span className="wk-social-link-label">Twitter</span>
                </a>*/}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </footer>
  )
}
export default Footer
